<template>

  <div class="yulan_wrap invoice_wrap">

    <!--公共样式部分 发票类型 发票状态 灰层-->
    <div class="invoice_base">
      <p class="invoice_type_car">
        <!-- <span id="invoiceType">普</span> -->
      </p>
      <span
        :class="['invoice_state',invoiceState]"
        id="invoiceState"
      ></span>
      <!--异常：abnormal，失控：outcontrol，红冲：red，作废：void-->
      <!-- <div class="mask"></div> -->
      <i class="iconfont icon-yinzhang check_result_icon"></i>
    </div>

    <div class="cms_r_main">

      <h1 class="invoice_tit"><span id="invoiceTit">

          {{invoiceData.invoiceType || "机动车销售统一发票"}}
        </span></h1>
      <table
        style="width: 100%;"
        border="0"
        cellspacing="0"
        cellpadding="0"
      >
        <tbody>
          <tr height="30">
            <td class="align_left">发票代码：<span
                class="content_td_blue"
                id="invoiceCode"
              > {{invoiceData.invoiceCode}} </span></td>
            <td>&nbsp;</td>
            <td class="align_left">发票号码：<span
                class="content_td_blue"
                id="invoiceNumber"
              >{{invoiceData.invoiceNumber}}</span></td>
            <td>&nbsp;</td>
            <td class="align_left">开票日期：<span
                class="content_td_blue"
                id="billingDate"
              >{{farmatData(invoiceData.billingDate)}}</span></td>
            <td>&nbsp;</td>
            <td class="align_left">&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
      <table
        class="fppy_table"
        style="width: 100%;"
        border="0"
        cellspacing="0"
        cellpadding="0"
      >
        <tbody>
          <tr>
            <td class="align_center">
              <p style="width: 99px;">机 打 代 码</p>
              <p>机 打 号 码</p>
              <p>机 器 编 号</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="3"
            >
              <p
                class="content_td_blue"
                id="jddm_invoiceCode"
              >{{invoiceData.invoiceCode}}</p>
              <p
                class="content_td_blue"
                id="jdhm_invoiceNumber"
              >
                {{invoiceData.invoiceNumber}}
              </p>
              <p
                class="content_td_blue"
                id="machineCode"
              >{{invoiceData.machineCode}}</p>
            </td>
            <td class="align_center">
              <p>税</p>
              <p>控</p>
              <p>码</p>
            </td>
            <td
              class="align_center"
              id="skm_jdcfp"
              colspan="6"
            >&nbsp;</td>
          </tr>
          <tr>
            <td class="align_center">
              <p>购买方名称及</p>
              <p>身份证号码/</p>
              <p>组织机构代码</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="4"
            >
              <p
                class="content_td_blue"
                id="purchaserName"
              >{{invoiceData.purchaserName}}</p>
              <p
                class="content_td_blue"
                id="idCardNo"
              >{{invoiceData.idCardNo}}</p>
            </td>
            <td class="align_center">纳税人识别号</td>
            <td
              class="align_left"
              colspan="4"
            >
              <p
                class="content_td_blue"
                id="purchaserTaxNo"
              >{{invoiceData.purchaserTaxNo}}</p>
            </td>
          </tr>
          <tr>
            <td class="align_center">
              <p>车 辆 类 型</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="2"
            ><span
                class="content_td_blue"
                id="vehicleType"
              >{{invoiceData.vehicleType}}</span></td>
            <td
              class="align_center"
              nowrap=""
            >厂牌型号</td>
            <td
              class="align_left"
              colspan="3"
            >
              <p
                class="content_td_blue"
                id="brandModel"
              >{{invoiceData.brandModel}}</p>
            </td>
            <td class="align_center">产地</td>
            <td
              class="align_left"
              colspan="2"
            >
              <p
                class="content_td_blue"
                id="originPlace"
              >{{invoiceData.originPlace}}</p>
            </td>
          </tr>
          <tr>
            <td class="align_center">合 格 证 号</td>
            <td
              class="align_left"
              nowrap=""
              colspan="2"
            ><span
                class="content_td_blue"
                id="certificateNo"
              >{{invoiceData.certificateNo}}</span></td>
            <td
              class="align_center"
              nowrap=""
              colspan="2"
            >进口证明书号</td>
            <td
              class="align_left"
              colspan="2"
            ><span
                class="content_td_blue"
                id="importCertificateNo"
              > {{invoiceData.importCertificateNo}}</span></td>
            <td class="align_center">商检单号</td>
            <td
              class="align_left content_td_blue"
              id="inspectionListNo"
              colspan="2"
            >{{invoiceData.inspectionListNo}} </td>
          </tr>
          <tr>
            <td class="align_center">发动机号码</td>
            <td
              class="align_left content_td_blue"
              id="engineNo"
              nowrap=""
              colspan="4"
            >{{invoiceData.engineNo}}</td>
            <td
              class="align_center"
              nowrap=""
            >车辆识别代号/车架号码</td>
            <td
              class="align_left content_td_blue"
              id="vehicleNo"
              nowrap=""
              colspan="4"
            >{{invoiceData.vehicleNo}}</td>
          </tr>
          <tr>
            <td class="align_center">价 税 合 计</td>
            <td
              class="borderLeft align_left"
              nowrap=""
              colspan="5"
            ><span
                class="content_td_blue align_left"
                id="amountTaxCn"
              >⊗ {{invoiceData.amountTaxCn}}</span></td>
            <td
              class="borderRight align_right"
              nowrap=""
              colspan="4"
            ><span style="padding: 0px 20px;">小写</span><span
                class="content_td_blue align_right"
                id="amountTax"
              >￥{{invoiceData.amountTax}}</span></td>
          </tr>
          <tr>
            <td class="align_center">销货单位名称</td>
            <td
              class="align_left content_td_blue"
              id="salesName"
              nowrap=""
              colspan="4"
            >{{invoiceData.salesName}}</td>
            <td class="align_center">电话</td>
            <td
              class="align_left content_td_blue"
              id="salesPhone"
              colspan="4"
            >{{invoiceData.salesPhone}}</td>
          </tr>
          <tr>
            <td class="align_center">纳税人识别号</td>
            <td
              class="align_left content_td_blue"
              id="salesTaxNo"
              nowrap=""
              colspan="4"
            >{{invoiceData.salesTaxNo}}</td>
            <td class="align_center">账号</td>
            <td
              class="align_left content_td_blue"
              id="salesBankNo"
              colspan="4"
            >{{invoiceData.salesBankNo}}</td>
          </tr>
          <tr>
            <td class="align_center">地 址</td>
            <td
              class="align_left"
              colspan="3"
            >
              <p
                class="content_td_blue"
                id="salesAddress"
              >{{invoiceData.salesAddress}}</p>
            </td>
            <td
              class="align_center"
              nowrap=""
            >开户银行</td>
            <td
              class="align_left"
              colspan="5"
            >
              <p
                class="content_td_blue"
                id="salesBank"
              >{{invoiceData.salesBank}}</p>
            </td>
          </tr>
          <tr>
            <td class="align_center">
              <p>增值税税率</p>
              <p>或 征 收 率</p>
            </td>
            <td
              width="20%"
              nowrap=""
            >
              <p
                class="content_td_blue align_center"
                id="vatTaxRate"
              >{{invoiceData.vatTaxRate}}</p>
            </td>
            <td
              class="align_center"
              nowrap=""
            >
              <p>增值税</p>
              <p>税额</p>
            </td>
            <td
              class="align_center"
              nowrap=""
            >
              <p
                class="content_td_blue"
                id="totalTax"
              >￥{{invoiceData.totalTax}}</p>
            </td>
            <td class="align_center">
              <p>主管税务</p>
              <p>机关及代码</p>
            </td>
            <td
              class="align_left"
              colspan="5"
            >
              <p
                class="content_td_blue"
                id="taxAuthorityName"
              >{{invoiceData.taxAuthorityName}}</p>
              <p
                class="content_td_blue"
                id="taxAuthorityNo"
              >{{invoiceData.taxAuthorityNo}}</p>
            </td>
          </tr>
          <tr>
            <td
              width="10%"
              class="align_center"
            >不 含 税 价</td>
            <td
              width="20%"
              class="align_left"
              nowrap=""
              colspan="2"
            >小写
              <span
                class="content_td_blue"
                id="totalAmount"
              >{{invoiceData.totalAmount}}</span>
            </td>
            <td
              width="15%"
              class="align_center"
              nowrap=""
            >完税凭证号码</td>
            <td
              width="24%"
              class="align_center"
              colspan="2"
            >
              <p
                class="content_td_blue"
                id="paymentVoucherNo"
              >{{invoiceData.paymentVoucherNo}} </p>
            </td>
            <td
              width="5%"
              class="align_center"
            >吨位</td>
            <td
              width="8%"
              class="align_center"
            >
              <p
                class="content_td_blue"
                id="Tonnage"
              >{{invoiceData.tonnage}}</p>
            </td>
            <td
              width="10%"
              class="align_center"
            >限乘人数</td>
            <td
              width="8%"
              class="align_center"
            >
              <p
                class="content_td_blue"
                id="passengersLimited"
              >{{invoiceData.passengersLimited}}</p>
            </td>
          </tr>
          <!--表头-->
          <!--表头结束-->
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'InvoiceCar',
  data() {
    return {
      invoiceConClass: true,
    };
  },
  props: ['invoiceData', 'invoiceState', 'invoiceTypes', 'invoiceTit'],
  mounted() {
  },
  methods: {
    farmatData(date) {
      if (!date) return '';
      console.log('date===', date);
      return moment(date).format('YYYY 年 MM 月 DD 日');
    },
  },
};
</script>
<style scoped  src="../invoice.css"></style>
<style scoped  src="../checkResult.css"></style>
<style  scoped>
.invoice_wrap {
  font-size: 10px;
}
</style>
